interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function ArrowRightIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M15.7063 8.70625C16.0969 8.31563 16.0969 7.68125 15.7063 7.29063L11.7063 3.29063C11.3156 2.9 10.6812 2.9 10.2906 3.29063C9.9 3.68125 9.9 4.31563 10.2906 4.70625L12.5844 7H1C0.446875 7 0 7.44688 0 8C0 8.55313 0.446875 9 1 9H12.5844L10.2906 11.2938C9.9 11.6844 9.9 12.3188 10.2906 12.7094C10.6812 13.1 11.3156 13.1 11.7063 12.7094L15.7063 8.70938V8.70625Z" />
    </svg>
  );
}
